import { createFileRoute } from "@tanstack/react-router";
import { FallbackEmpty } from "~/components/FallbackEmpty";
import { useFeatureFlags } from "~/hooks/useFeatureFlags";

export const Route = createFileRoute("/(restricted)/virksomheder-v2/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { flags } = useFeatureFlags();

  if (!flags.COMPANIES_V2_ENABLED) return <FallbackEmpty />;

  return null;
}
